///<reference path="../Core/Resources.js"/>
window.localizedStrings["view"] = {
  thisweeklabel: "This Week",
  thismonthlabel: "This Month",
  thisyearlabel: "This Year",
  yeartodatelabel: "Year to Date",
  lastweeklabel: "Last Week",
  lastmonthlabel: "Last Month",
  last30label: "Last 30 Days",
  last60label: "Last 60 Days",
  last90label: "Last 90 Days",
  lastyearlabel: "Last Year",
  nextweeklabel: "Next Week",
  nextmonthlabel: "Next Month",
  next30label: "Next 30 Days",
  next60label: "Next 60 Days",
  next90label: "Next 90 Days",
  nextyearlabel: "Next Year",
  closeconfirm:
    "You might lose data if you close at this time. Are you sure you want to close?",
  documentbodyerror:
    "Error:  Document body is null.  This happens when the view.js is processed before the body tag.  Correct the aspx page.",
  warningtitle: "Warning",
  invalidlabel: "Invalid format",
  decimalerror: "'{0}' is not a valid decimal.",
  infoviewercontinue:
    "You might lose data if you leave this record. Are you sure you want to continue?",
  commandmode: "Entering command mode",
  editmode: "Entering edit mode"
};
